import { cleanDoubleSlashes } from "ufo";

export const ROOM_URL_TEMPLATES = {
  ROOM_URL: "{{ROOM_URL}}",
  AUTH_TOKEN: "{{AUTH_TOKEN}}",
  LOCALE: "{{LOCALE}}",
  QTAG: "{{QTAG}}",
} as const;

export type RoomTemplateKey = keyof typeof ROOM_URL_TEMPLATES;
/**
 * Подставляет значения в шаблон URL вида:
 * "{{ROOM_URL}}/?locale={{LOCALE}}&auth={{AUTH_TOKEN}}"
 * Результат:
 * "https://jack-playcard.com/?locale=en&auth=&page=home"
 */
export const parseUrlTemplateAndBuildUrl = (
  template: string,
  params: Partial<Record<RoomTemplateKey, string | undefined>>,
): string => {
  return cleanDoubleSlashes(
    Object.keys(ROOM_URL_TEMPLATES).reduce((result, key) => {
      const value = params[key as RoomTemplateKey] ?? "";
      return result.replaceAll(
        ROOM_URL_TEMPLATES[key as RoomTemplateKey],
        value,
      );
    }, template),
  );
};
